import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { StihlUserDTO } from '../../models/stihl-user-dto';
import { UserService } from '../../services/user.service';
import { TrackingService } from 'src/app/services/tracking.service';
import { NavigationEnd, Router, ActivatedRoute, ChildrenOutletContexts } from '@angular/router';
import { LogType } from 'src/app/enums/logType';
import { fadeInOutAnimation } from 'src/app/animations';
import { filter } from 'rxjs/operators';

@Component({
  templateUrl: './default-layout.component.html',
  animations: [fadeInOutAnimation]
})
export class DefaultLayoutComponent implements OnInit {

  useSSO = environment.useSSO;
  userInfo: StihlUserDTO;

  // BRAND DAY
  showLayer = false;

  constructor(
    private userService: UserService,
    private trackingService: TrackingService,
    private router: Router,
    private contexts: ChildrenOutletContexts,
    private activatedRoute: ActivatedRoute// BRAND DAY
  ) {

    this.getUserInfo();

    setTimeout(() => {
      this.router.events
        .pipe(filter(ev => ev instanceof NavigationEnd))
        .subscribe(() => {
          this.trackUser(LogType.Nav);
          this.toggleAdminStyleClass();
          this.updateShowLayerFromRoute();// BRAND DAY
        });
    }, 1500);

  }

  ngOnInit() {
    this.trackUser(LogType.Login);
    this.toggleAdminStyleClass();
    this.updateShowLayerFromRoute();// BRAND DAY
  }

  getAnimationData() {
    return this.contexts.getContext('primary')?.route?.snapshot?.data?.['animation'];
  };
  
  // BRAND DAY
  private updateShowLayerFromRoute(): void {
    let route = this.activatedRoute.root;
    while (route.firstChild) route = route.firstChild;
    this.showLayer = route.snapshot.data?.['showLayer'] === false;
  }

  getUserInfo() {
    this.userService.getUserInfo().subscribe(res => {
      this.userService.setUserData(res);
      this.userInfo = res;
    });
  }

  trackUser(idLogType) {
    this.trackingService.trackUser({ IdLogType: idLogType, Url: this.router.url }).subscribe();
  }

  toggleAdminStyleClass() {
    let body = document.getElementsByTagName('body')[0];
    if (this.router.url.includes('/adm/')) {
      body.classList.add('admin-layout');
    } else {
      body.classList.remove('admin-layout');
    }
  }
}
